import { useQuery } from 'data-fetching-client';
import get from 'hs-lodash/get';
import { GET_ALL_OUTPUTS } from 'automation-ui-action-features/queries/GetAllOutputsQuery';
import { createActionMap, getActionOutputsForTargetActionById } from 'automation-ui-action-features/records/recordsUtils';

// TODO: Change this to `HybridFlow` once automation-ui-flow cleanup is done

export const useActionOutputs = flow => {
  var _data$allOutputs;
  const {
    data,
    previousData,
    loading,
    refetch,
    error
  } = useQuery(GET_ALL_OUTPUTS, {
    skip: !(flow !== null && flow !== void 0 && flow.flowId),
    fetchPolicy: 'cache-and-network',
    variables: {
      flowId: flow && flow.flowId,
      flowVersion: flow && flow.version
    }
  });
  const allOutputs = get(data, 'allOutputs') || get(previousData, 'allOutputs');
  const instanceOutputsByActionId = get(allOutputs, 'instanceOutputs');
  const allOutputsByActionTypeId = get(allOutputs, 'actionTypeOutputs');
  return {
    actionDefaultOutputs: data === null || data === void 0 || (_data$allOutputs = data.allOutputs) === null || _data$allOutputs === void 0 ? void 0 : _data$allOutputs.actionDefaultOutputs,
    instanceOutputsByActionId,
    allOutputsByActionTypeId,
    isActionOutputsLoading: loading,
    refetch,
    error
  };
};
export const useGetActionOutputsForTargetActionById = flow => {
  const {
    instanceOutputsByActionId,
    allOutputsByActionTypeId
  } = useActionOutputs(flow);
  return (targetActionId, isNewAction) => getActionOutputsForTargetActionById({
    actions: createActionMap(flow),
    allOutputsByActionTypeId,
    instanceOutputsByActionId,
    targetActionId,
    isNewAction
  });
};